module.exports = {
    // API_LOCATION: 'http://jhf-admin.test/api/',
    API_LOCATION: 'https://admin.japanhomefinder.com/api/',
    GOOGLE_MAP_KEY:'AIzaSyBT5elHt52KehQe9IH9Wo3OhDjds0upi0w',
    // GOOGLE_MAP_KEY:'AIzaSyAjnGatt9_xCpj9-Qv-EFsGkbylH3TF8cU', -- google map key for us
    API_URL:'https://admin.japanhomefinder.com',
    INQUIRE_EMAIL:'info@interlinknagoya.com',
    MAP_STYLE:{
      disableDefaultUI: true,
      scrollwheel: true,
      scaleControl: true,
      rotateControl: true,
      zoomControl: true,
      zoomControlOptions: {
        position: 8
      },
        styles: [
            {
              "stylers": [
                {
                  "saturation": "-19"
                },
                {
                  "visibility": "simplified"
                }
              ]
            },
            {
              "featureType": "administrative",
              "stylers": [
                {
                  "visibility": "on"
                }
              ]
            },
            {
              "featureType": "administrative.country",
              "stylers": [
                {
                  "visibility": "on"
                }
              ]
            },
            {
              "featureType": "administrative.land_parcel",
              "elementType": "geometry",
              "stylers": [
                {
                  "visibility": "on"
                }
              ]
            },
            {
              "featureType": "administrative.locality",
              "stylers": [
                {
                  "visibility": "on"
                }
              ]
            },
            {
              "featureType": "administrative.neighborhood",
              "stylers": [
                {
                  "visibility": "on"
                }
              ]
            },
            {
              "featureType": "administrative.province",
              "stylers": [
                {
                  "visibility": "on"
                }
              ]
            },
            {
              "featureType": "landscape",
              "stylers": [
                {
                  "visibility": "on"
                }
              ]
            },
            {
              "featureType": "landscape.man_made",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "poi",
              "stylers": [
                {
                  "visibility": "simplified"
                }
              ]
            },
            {
              "featureType": "poi.attraction",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "poi.business",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "road",
              "stylers": [
                {
                  "hue": "#0069ff"
                },
                {
                  "visibility": "on"
                }
              ]
            },
            {
              "featureType": "road",
              "elementType": "geometry",
              "stylers": [
                {
                  "visibility": "on"
                }
              ]
            },
            {
              "featureType": "road",
              "elementType": "geometry.fill",
              "stylers": [
                {
                  "visibility": "on"
                }
              ]
            }
        ]
    }
}
